<template>
<div>
  <v-row no-gutters class="px-1 pt-3 pb-0">
    <div style="display: inline-block;">
      <span class="view-title" id="v-step-0">{{ viewTitle }}</span>
      <!-- 位置調整用 -->
    </div>
    <div style="display: inline-block;padding-top:2px" class="mr-2">
      <dd-icon-button-with-tooltip
        v-if="isUseGuide"
        addClass="d-none d-sm-block"
        color="green"
        message="操作ガイドを表示します"
        icon="mdi-help-box"
        @click="onClickUseGuideClick"/>
    </div>
    <span class="mt-1" v-if="isShowCreateButton">
      <dd-custom-button
      :rounded="true"
      :minWidth="60"
      :small="true"
      @click="onCreateButtonClick">
        {{ functionName }}を新規追加する
      </dd-custom-button>
    </span>
  </v-row>

  <hr class="section-line">

  <!-- 検索条件 -->
  <div class="pa-2">
    <v-row no-gutters>
      <v-col :cols="12">
        <v-row no-gutters justify="start">
          <dd-sub-header>
            <span>以下の検索条件で絞り込む</span>
            <span style="float: right;">
              <dd-transparent-button
                v-if="isConditionHide"
                :rounded="true"
                :minWidth="100"
                @click="onSearchButtonClick">
                <v-icon>mdi-magnify</v-icon>
                検索をする
              </dd-transparent-button>
              <dd-transparent-button :minWidth="140" @click="isConditionHide = !isConditionHide">
                <div v-if="!isConditionHide" class="condition-expansion">検索条件を閉じる<v-icon>mdi-chevron-up</v-icon></div>
                <div v-else class="condition-expansion">検索条件を開く<v-icon>mdi-chevron-down</v-icon></div>
              </dd-transparent-button>
            </span>
          </dd-sub-header>
        </v-row>
        <div v-if="!isConditionHide" class="px-1 pt-0 pb-2 condition-area">
          <v-row no-gutters ref="_calcHeight-Row1">
            <v-col :cols="12">
              <span class="ml-1 view-description" v-if="description === ''">登録済み{{functionName}}を検索したい条件を入力して[検索をする]を押下してください。
                <span v-if="isShowCreateButton">新規に{{functionName}}を追加する場合は[{{ functionName }}を新規追加する]ボタンを押下してください。</span></span>
              <span class="ml-1 view-description" v-else>{{description}}</span>
            </v-col>
          </v-row>
          <slot>
          <!-- 任意設定エリア -->
          </slot>
          <v-row class="mt-2" no-gutters justify="center">
            <dd-custom-button
              :rounded="true"
              :minWidth="200"
              :large="true"
              :tooltipText="searchToolTip === '' ? `入力された検索条件で登録済み${functionName}を検索します` : `${searchToolTip}`"
              :enableToolTip="helpUseFlg"
              :tooltipBottom="true"
              @click="onSearchButtonClick">
              検索をする
            </dd-custom-button>
            <a
              class="condition-clear"
              @click="onClearButtonClick">
              条件をクリア
            </a>
          </v-row>
        </div>
        <div class="px-1 py-2 condition-area" v-show="isConditionHide && ![undefined, null].includes(conditionDetails)">
          <v-row no-gutters v-if="isConditionChange">
            <v-icon class="mx-1" color="green" small>mdi-information-outline</v-icon>
            <span style="font-size:0.8rem;color:green;">条件が変更されました。「検索をする」で再読み込みしてください。</span>
          </v-row>
          <v-row no-gutters>
            <span style="display: inline-block">
              <span v-for="item in conditionDetails" :key="item.key">
                <v-chip class="mx-1" color="#4169e1" small dark :close="item.delete" v-if="item.type !== 'checkbox' && ![undefined, null, ''].includes(conditions[item.key]) || (item.type === 'checkbox' && conditions[item.key] === true)" @dblclick="isConditionHide = false" @click:close="onRemoveConditionClick(item.key, item.type)">
                  <!--
                  <span>{{item.name}}：</span><span style="color:greenyellow">{{ conditions[item.value] }}</span>
                  -->
                  <span>{{ getItemName(item) }}</span><span style="color:greenyellow;white-space: pre-wrap;">{{ getItemValue(item) }}</span>
                </v-chip>
              </span>
            </span>
          </v-row>
        </div>
      </v-col>
    </v-row>
  </div>
</div>
</template>

<script>
import DdCustomButton from '@/components/DdCustomButton'
import DdTransparentButton from '@/components/DdTransparentButton'
import { mapGetters } from 'vuex'

const DdIconButtonWithTooltip = () => import('@/components/DdIconButtonWithTooltip')
const DdSubHeader = () => import('@/components/DdSubHeader')

export default {
  name: 'DdListHeader',
  props: {
    // 画面タイトル
    viewTitle: String,
    /**
     * 機能名
     */
    functionName: String,
    /**
     * 追加ボタン表示
     */
    isShowCreateButton: {
      type: Boolean,
      default: true
    },
    description: {
      type: String,
      default: ''
    },
    searchToolTip: {
      type: String,
      default: ''
    },
    isUseGuide: {
      type: Boolean,
      default: false
    },
    /**
     * 検索後条件非表示
     */
    isConditionHideAfterSearch: {
      type: Boolean,
      default: false
    },
    /**
     * 検索条件
     */
    conditions: Object,
    /**
     * 検索条件簡易表示用
     */
    conditionDetails: Array
  },
  components: {
    DdCustomButton,
    DdTransparentButton,
    DdIconButtonWithTooltip,
    DdSubHeader
  },
  data: () => ({
    isConditionHide: false,
    // 条件変更
    isConditionChange: false
  }),
  computed: {
    ...mapGetters({
      shubetsuList: 'DDMasters/mstShubetsu',
      kubunList: 'DDMasters/msysKubun',
      eigyoshoList: 'DDMasters/mstEigyosho',
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      sharyoList: 'DDMasters/vwCMstSharyo',
      jininList: 'DDMasters/vwCMstEigyoshoJininList',
      helpUseFlg: 'users/helpUseFlg'
    })
  },
  created () {
  },
  mounted () {
  },
  methods: {
    onClickUseGuideClick: function () {
      this.$emit('guideOn')
    },
    onCreateButtonClick: function () {
      this.$emit('create')
    },
    onSearchButtonClick: function () {
      this.$emit('search')
      if (this.isConditionHideAfterSearch) {
        this.isConditionChange = false
        this.isConditionHide = true
      }
    },
    onClearButtonClick: function () {
      this.$emit('clear')
    },
    onRemoveConditionClick: function (itemNm) {
      this.isConditionChange = true
      this.$emit('removeCondition', itemNm)
    },

    getItemName: function (item) {
      if (item.type === 'checkbox') {
        console.log(item.name, this.conditions[item.key])
        return this.conditions[item.key] === true ? item.name : ''
      } else {
        return item.name + (item.showValue ? '：' : '')
      }
    },
    getItemValue: function (item) {
      console.log('getItemValue', this.conditions, item)
      if (!item.showValue) return ''

      if (item.convertValue === true) {
        return this.getItemValueFromMasterData(item)
      } else {
        if ([undefined, null].includes(item.value)) return ''

        const dotIndex = item.value.indexOf('.')
        if (dotIndex > 0) {
          const itemArray = item.value.split('.')
          console.log(this.conditions[itemArray[0]][itemArray[1]])
          return this.conditions[itemArray[0]][itemArray[1]]
        } else {
          return this.conditions[item.value]
        }
      }
    },
    getItemValueFromMasterData: function (item) {
      console.log('getItemValueFromMasterData', item)
      var rtnVal = ''
      const self = this
      if (item.master === 'mstshubetsu') {
        const m = self.shubetsuList.filter((elem) => {
          return elem.kaishaCd === self.currentKaishaCode && elem.sbtShuruiCd === item.kbnShuruiCd && elem.sbtCd === self.conditions[item.key]
        })
        if (m.length > 0) {
          rtnVal = m[0].sbtNm
        } else {
          rtnVal = ''
        }
      } else if (item.master === 'msyskubun') {
        const m = self.kubunList.filter((elem) => {
          return elem.kaishaCd === self.currentKaishaCode && elem.kbnShuruiCd === item.kbnShuruiCd && elem.code === self.conditions[item.key]
        })
        if (m.length > 0) {
          rtnVal = m[0].codeNm
        } else {
          rtnVal = ''
        }
      } else if (item.master === 'msteigyosho') {
        const m = self.eigyoshoList.filter((elem) => {
          return (item.key.slice(-2) === 'Id' && elem.id === self.conditions[item.key]) ||
                  (item.key.slice(-2) === 'Cd' && elem.eigyoshoCd === self.conditions[item.key])
        })
        if (m.length > 0) {
          rtnVal = m[0].eigyoshoNm
        } else {
          rtnVal = ''
        }
      } else if (item.master === 'msttorihikisaki') {
        const m = self.torihikisakiList.filter((elem) => {
          return (item.key.slice(-2) === 'Id' && elem.id === self.conditions[item.key]) ||
                  (item.key.slice(-2) === 'Cd' && elem.torihikisakiCd === self.conditions[item.key])
        })
        if (m.length > 0) {
          rtnVal = m[0].torihikisakiNm
        } else {
          rtnVal = ''
        }
      } else if (item.master === 'mstsharyo') {
        const m = self.sharyoList.filter((elem) => {
          return (item.key.slice(-2) === 'Id' && elem.id === self.conditions[item.key]) ||
                  (item.key.slice(-2) === 'Cd' && elem.sharyoCd === self.conditions[item.key])
        })
        if (m.length > 0) {
          rtnVal = m[0].jidoshaHyojiNm
        } else {
          rtnVal = ''
        }
      } else if (item.master === 'mstjinin') {
        const m = self.jininList.filter((elem) => {
          return (item.key.slice(-2) === 'Id' && elem.id === self.conditions[item.key]) ||
                  (item.key.slice(-2) === 'Cd' && elem.jininCd === self.conditions[item.key])
        })
        if (m.length > 0) {
          rtnVal = m[0].jininNmSei
        } else {
          rtnVal = ''
        }
      }
      return rtnVal
    }
  }
}
</script>
